export function normalizeImageWheelDelta(event: {
  deltaX: number;
  deltaY: number;
  shiftKey: boolean;
}) {
  return {
    deltaX: event.deltaX || (event.shiftKey ? event.deltaY : 0),
    deltaY: event.shiftKey ? 0 : event.deltaY,
  };
}
